import { useCallback, useState } from 'react'
import { StorageKeys } from '@/lib/storage/keys'

function readDense(): boolean {
  try {
    const stored = localStorage.getItem(StorageKeys.SIDEBAR_LIST_DENSITY)
    if (stored === 'dense') return true
    if (stored === 'comfortable') return false
  } catch {
    /* ignore */
  }
  return false
}

/** Sidebar-wide list density (replaces per-panel inbox-only control). */
export function useSidebarDensity() {
  const [dense, setDenseState] = useState(() => readDense())

  const setDense = useCallback((next: boolean) => {
    setDenseState(next)
    try {
      localStorage.setItem(
        StorageKeys.SIDEBAR_LIST_DENSITY,
        next ? 'dense' : 'comfortable',
      )
    } catch {
      /* ignore */
    }
  }, [])

  return { dense, setDense }
}
